import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import Button from '@adsk/bim360-matrix-react-button';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENTITY_TYPES } from './helpers/consts';
import { entityShape, pluginShape } from './helpers/propTypes';
import InlineLoader from './InlineLoader';

import './_EntityPickerEntitiesList.scss';

const EntityPickerEntitiesList = ({
  plugin,
  onChange,
  entityType,
  isLoading,
  entities,
  onLoadMore,
  manuallySelectedIds,
  linkedEntityIds,
  error,
  onTryAgain,
  disabled
}) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));

  return (
    <div className="EntityPickerEntitiesList">
      {entities.map(entity => {
        const { EntityPickerItem } = plugin;
        return (
          <EntityPickerItem
            key={entity.id}
            entity={entity}
            onChange={checked => onChange({ entity, entityType, checked })}
            disabled={disabled || linkedEntityIds.includes(entity.id)}
            isSelected={
              manuallySelectedIds.includes(entity.id) || linkedEntityIds.includes(entity.id)
            }
          />
        );
      })}
      {isLoading && <InlineLoader className="EntityPickerEntitiesList__loader" />}
      {onLoadMore && !isLoading && !error && (
        <Button
          styleType={Button.StyleType.INLINE_LINK}
          className="EntityPickerEntitiesList__load-more"
          onClick={onLoadMore}
          disabled={disabled}
        >
          {T.translate('LOAD_MORE')}
        </Button>
      )}
      {error && !isLoading && (
        <div className="EntityPickerEntitiesList__error">
          <span className="EntityPickerEntitiesList__error-text">
            {T.translate('ERROR_LOADING')}
          </span>
          <Button
            className="EntityPickerEntitiesList__error-button"
            styleType={Button.StyleType.INLINE_LINK}
            onClick={onTryAgain}
            disabled={disabled}
          >
            {T.translate('TRY_AGAIN')}
          </Button>
        </div>
      )}
    </div>
  );
};

EntityPickerEntitiesList.propTypes = {
  plugin: pluginShape,
  onChange: PropTypes.func.isRequired,
  entityType: PropTypes.oneOf(objectValues(ENTITY_TYPES)).isRequired,
  isLoading: PropTypes.bool,
  onLoadMore: PropTypes.func,
  error: PropTypes.bool,
  onTryAgain: PropTypes.func,
  manuallySelectedIds: PropTypes.arrayOf(PropTypes.string),
  linkedEntityIds: PropTypes.arrayOf(PropTypes.string),
  entities: PropTypes.arrayOf(entityShape).isRequired,
  disabled: PropTypes.bool
};

export default EntityPickerEntitiesList;
